import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Tableau commun de liens
  const navLinks = [
    { path: "/produits", label: "Produits" },
    { path: "/revendeurs", label: "Revendeurs" },
    { path: "/a-propos", label: "À propos" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <header className="header" role="banner">
      <div className="nav" role="navigation" aria-label="Navigation principale">
        {/* Burger menu */}
        <button
          className="burger-menu"
          aria-label="Ouvrir le menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>

        {/* Logo centré */}
        <div className="brand">
          <Link to="/" className="brand-link" aria-label="Accueil TresorSafe">
            <img
              src="/TresorSafeLogo.jpeg"
              alt="logo TresorSafe"
              className="logo"
            />
            <span className="brand-name">The TresorSafe</span>
          </Link>
        </div>

        {/* Liens desktop */}
        <nav className="links desktop-links">
          {navLinks.map((link) => (
            <NavLink key={link.path} to={link.path}>
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Liens mobile (affichés quand burger cliqué) */}
      {menuOpen && (
        <nav className="mobile-menu">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
